<template>
    <PageWrapper
      :isLoading="isLoading"
    >
      <template #title>لیست پکیج های مشاوره</template>
      <template #titleBtn>
      <BButton @click="renderCreatePackageModal" variant="success">
        ایجاد پکیج جدید
      </BButton>
    </template>
  
      <CustomTable
      style="height: 100%;"
        :pageNumber="supportListFilters.pageNumber"
        :count="supportListFilters.count"
        :totalCount="totalCount"
        :tableColumns="tableColumns"
        :tableItems="supportList"
        @changePage="changePage"
      >
        <template #picUrl="data">
          <span
              class="icon-picker-icon"
              :style="{
                backgroundColor: JSON.parse(data.item.picUrl).background,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '36px',
                height: '36px',
                borderRadius: '15px',
                marginLeft: '10px'
              }"
            >
              <img :src="require(`@/assets/images/icons/picker/${JSON.parse(data.item.picUrl).value}.svg`)" alt="icon" style="width:22px;height:22px;" />
            </span>
        </template>
        <template #isShow="data">
        <div class="d-flex align-items-center justify-content-center">
          <b-badge
            class="font-weight-normal text-center"
            :variant="data.item.isShow ? 'success' : 'danger'"
          >
            {{ data.item.isShow ? "قابل نمایش" : "عدم نمایش" }}
          </b-badge>
        </div>
      </template>
        <template #actions="data">
            <span
                class="btn p-0 m-0"
                v-b-tooltip="'مشاهده جزئیات'"
                @click="renderUpdatePackageModal(data.item)"
            >
              <feather-icon
                  icon="ExternalLinkIcon"
                  class="text-primary"
                  size="20"
              />
            </span>
        </template>
      </CustomTable>
      <createSupportPackage 
      @refetch="getAllSupportList"
      />

      <updateSupportPackage 
      :packageData="editablePackageData"
      @refetch="getAllSupportList"
      />

    </PageWrapper>
  </template>
  
  <script>
  import {BLink, VBTooltip} from "bootstrap-vue";
  
  export default {
    mounted() {
      if (this.computedPageRouteQuery) {
        this.supportListFilters.pageNumber = this.computedPageRouteQuery;
      }
  
      this.getAllSupportList();
    },
  
    data() {
      return {
        isLoading: false,
        editablePackageData:null,
        supportList: null,
        totalCount: null,
        queryDate: {
          startDate: null,
          endDate: null,
        },
        supportListFilters: {
          pageNumber: 1,
          count: 10,
          startDateTime: null,
          endDateTime: null,
          studentFullName: null,
          masterFullName: null,
        },
  
        tableColumns: [
          {
            key: "counselingPackageId",
            label: "شناسه",
          },
          {
            key: "title",
            label: "عنوان",
          },
          {
            key: "description",
            label: "توضیحات",
          },
          {
            key: "expiryDay",
            label: "مدت زمان پکیج",
            formatter: (value) => `${value || 0} روز`,

          },
          {
            key: "totalCallMin",
            label: "زمان مشاوره",
            formatter: (value) => `${value || 0} دقیقه`,
          },
          {
            key: "totalCallMinOnDay",
            label: "حداکثر مشاور در روز",
            formatter: (value) => `${value || 0} دقیقه`,
          },
          {
            key: "price",
            label: "قیمت",
            formatter: (value) =>
                value ? `${Intl.NumberFormat("en-US").format(value)} تومان` : "-",
          },
          {
            key: "picUrl",
            label: "تصویر",
          },
          {
          key: "isShow",
          label: "وضعیت نمایش",
        },
          {
            key: "actions",
            label: "عملیات",
          },
        ],
      };
    },
  
    methods: {

        renderCreatePackageModal() {
      this.$bvModal.show("modal-supportPackage-add");
    },

      renderUpdatePackageModal(counselDate){
        this.editablePackageData = counselDate
        this.$bvModal.show("modal-supportPackage-update");
      },
  
      setPageNumberAndSendRequest() {
        this.supportListFilters.pageNumber = 1;
        this.setPageNumberQuery(1);
        this.getAllSupportList();
      },
  
      changePage(pageNumber) {
        this.supportListFilters.pageNumber = pageNumber;
        this.setPageNumberQuery(pageNumber);
        this.getAllSupportList();
      },
  
      setPageNumberQuery(pageNumber) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            page: pageNumber,
          },
        });
      },
  
      async getAllSupportList() {
        try {
          this.isLoading = true;
  
          const _this = this;
  
          const getAllConsultList = new ListCounselingPackageForAdmin(_this);
          getAllConsultList.setRequestParamDataObj(_this.supportListFilters);
  
          await getAllConsultList.fetch((res) => {
            if (res.isSuccess) {
              _this.supportList = res.data.data;
              _this.totalCount = res.data.total;
            }
          });
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoading = false;
        }
      },
    },
  
    computed: {
      computedPageRouteQuery() {
        if (this.$route.query && this.$route.query.page) {
          return this.$route.query.page;
        }
        return null;
      },
    },
    directives: {
      BTooltip: VBTooltip,
    },
    components: {
      PageWrapper,
      CustomTable,
      SearchInput,
      BLink,
      BBadge,
      BButton,
      createSupportPackage,
      updateSupportPackage,
      LanguagePicker
    },
  };
  import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
  import CustomTable from "@/views/components/Utils/CustomTable.vue";
  import SearchInput from "@/views/components/Utils/SearchInput.vue";
  import createSupportPackage from "./createSupportPackage.vue"
  import updateSupportPackage from "./updateSupportPackage.vue"
  import { BButton,BBadge } from "bootstrap-vue";
  import { ListCounselingPackageForAdmin } from "@/libs/Api/Counseling";
  import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";

  </script>
  